export default __webpack_public_path__ + "static/media/do-1.7fc32f36.jpg";